import { useLogin } from "../utils/api.hook";
import { LoginComponent } from "./login.component";

export function LoginContainer() {
  const { mutateAsync: login, isLoading } = useLogin();

  return <LoginComponent login={login} isLoading={isLoading} />;
}
